import React, { useState, useEffect } from 'react';
import './MaintenancePage.css';

const MaintenancePage = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <img src="/logo.svg" alt="Abhyaas" className="maintenance-logo" />

        <div className="maintenance-icon">
          <svg viewBox="0 0 100 100" className="gear-icon">
            <circle cx="50" cy="50" r="35" fill="none" stroke="currentColor" strokeWidth="3"/>
            <circle cx="50" cy="50" r="25" fill="none" stroke="currentColor" strokeWidth="3"/>
            <circle cx="50" cy="15" r="5" fill="currentColor"/>
            <circle cx="85" cy="50" r="5" fill="currentColor"/>
            <circle cx="50" cy="85" r="5" fill="currentColor"/>
            <circle cx="15" cy="50" r="5" fill="currentColor"/>
            <circle cx="71" cy="29" r="5" fill="currentColor"/>
            <circle cx="71" cy="71" r="5" fill="currentColor"/>
            <circle cx="29" cy="71" r="5" fill="currentColor"/>
            <circle cx="29" cy="29" r="5" fill="currentColor"/>
          </svg>
        </div>

        <h1 className="maintenance-title">We're Upgrading!</h1>

        <p className="maintenance-subtitle">
          Abhyaas Parent Portal 2.0
        </p>

        <p className="maintenance-description">
          We're making your experience faster and better than ever.
          <br />
          The portal will be back shortly with lightning-fast performance.
        </p>

        <div className="maintenance-features">
          <div className="feature-item">
            <span className="feature-icon">⚡</span>
            <span className="feature-text">10x Faster Loading</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🎨</span>
            <span className="feature-text">Enhanced Design</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">📱</span>
            <span className="feature-text">Better Mobile Experience</span>
          </div>
        </div>

        <div className="maintenance-time">
          <p className="time-label">Current Time</p>
          <p className="time-display">{currentTime.toLocaleTimeString('en-IN', {
            timeZone: 'Asia/Kolkata',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          })}</p>
          <p className="time-date">{currentTime.toLocaleDateString('en-IN', {
            timeZone: 'Asia/Kolkata',
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}</p>
        </div>

        <div className="maintenance-footer">
          <p>Thank you for your patience!</p>
          <p className="footer-secondary">
            For urgent matters, please contact your school administrator
          </p>
        </div>

        <div className="pulse-loader">
          <div className="pulse-dot"></div>
          <div className="pulse-dot"></div>
          <div className="pulse-dot"></div>
        </div>
      </div>

      <div className="background-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
      </div>
    </div>
  );
};

export default MaintenancePage;
